// Collateral Suite pricing — extracted from MarketingCollateralCalculator
// so the Combined builder can include it as a section without code duplication.

export const COLLATERAL_DEFAULT_PRICES = {
  landing_page: 3000,
  full_website: 7500,
  branding: 10000,
  investment_presentation: 4000,
  flipbook: 7500,
  billboard_static: 1500,
  billboard_animated: 3000,
  unit_inventory: 750,
  ai_enhance: 599,
  ai_retainer_6: 5394,
  ai_retainer_12: 9708,
  ai_retainer_18: 13755,
};

export const COLLATERAL_RETAINER_TIERS = [
  { value: "none", label: "None", clips: 0, monthlyKey: null },
  { value: "6", label: "6 clips/mo", clips: 6, monthlyKey: "ai_retainer_6" },
  { value: "12", label: "12 clips/mo", clips: 12, monthlyKey: "ai_retainer_12" },
  { value: "18", label: "18 clips/mo", clips: 18, monthlyKey: "ai_retainer_18" },
];

/**
 * Calculate collateral subtotal & line items.
 * State shape (CollateralState):
 *   {
 *     toggles: { landing_page, full_website, branding, investment_presentation,
 *                flipbook, unit_inventory, ai_enhance },
 *     billboardOption: 'none' | 'static' | 'animated',
 *     aiRetainerTier: 'none' | '6' | '12' | '18',
 *     aiEnhanceQty: number,
 *     retainerMonths: number,
 *   }
 */
export function calculateCollateral(state, prices = COLLATERAL_DEFAULT_PRICES) {
  const t = state?.toggles || {};
  let oneTimeTotal = 0;
  const items = [];

  if (t.landing_page) { oneTimeTotal += prices.landing_page; items.push({ label: "Landing Page", amount: prices.landing_page }); }
  if (t.full_website) { oneTimeTotal += prices.full_website; items.push({ label: "Full Website", amount: prices.full_website }); }
  if (t.branding) { oneTimeTotal += prices.branding; items.push({ label: "Branding & Conceptual Package", amount: prices.branding }); }
  if (t.investment_presentation) { oneTimeTotal += prices.investment_presentation; items.push({ label: "Investment Presentation", amount: prices.investment_presentation }); }
  if (t.flipbook) { oneTimeTotal += prices.flipbook; items.push({ label: "Development Flipbook", amount: prices.flipbook }); }

  const billboardOption = state?.billboardOption || "none";
  const billboardPrice =
    billboardOption === "static" ? prices.billboard_static :
    billboardOption === "animated" ? prices.billboard_animated : 0;
  if (billboardPrice > 0) {
    oneTimeTotal += billboardPrice;
    items.push({ label: `Billboard Design (${billboardOption === "static" ? "Static" : "Animated"})`, amount: billboardPrice });
  }

  if (t.unit_inventory) { oneTimeTotal += prices.unit_inventory; items.push({ label: "Unit Inventory Breakdown Sheet", amount: prices.unit_inventory }); }

  const aiEnhanceQty = state?.aiEnhanceQty || 0;
  const aiEnhanceTotal = t.ai_enhance ? aiEnhanceQty * prices.ai_enhance : 0;
  if (aiEnhanceTotal > 0) {
    oneTimeTotal += aiEnhanceTotal;
    items.push({ label: `Advanced Render Enhancement (${aiEnhanceQty} images)`, amount: aiEnhanceTotal });
  }

  const retainerTier = state?.aiRetainerTier || "none";
  const retainerMonths = state?.retainerMonths || 0;
  const retainerTierMonthly = {
    "6": prices.ai_retainer_6,
    "12": prices.ai_retainer_12,
    "18": prices.ai_retainer_18,
  };
  const aiRetainerMonthly = retainerTier !== "none" ? (retainerTierMonthly[retainerTier] || 0) : 0;
  const aiRetainerTotal = aiRetainerMonthly * retainerMonths;

  const grandTotal = oneTimeTotal + aiRetainerTotal;
  const isEnabled = grandTotal > 0;

  return {
    isEnabled,
    oneTimeTotal,
    items,
    aiEnhanceTotal,
    aiRetainerMonthly,
    aiRetainerTotal,
    aiRetainerTier: retainerTier,
    retainerMonths,
    grandTotal,
  };
}

export const COLLATERAL_EMPTY_STATE = {
  toggles: {
    landing_page: false,
    full_website: false,
    branding: false,
    investment_presentation: false,
    flipbook: false,
    unit_inventory: false,
    ai_enhance: false,
  },
  billboardOption: "none",
  aiRetainerTier: "none",
  aiEnhanceQty: 3,
  retainerMonths: 6,
};
